module.exports = __webpack_public_path__ + "static/media/8.01ea9ff4.jpg";